import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const InstagramCircleV2 = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 80 80'
    >
      <circle cx='40' cy='40' r='39.78' fill='#fff'/>
      <path d='M52.05,12.31h-24.1c-8.63,0-15.65,7.02-15.65,15.65v24.1c0,8.63,7.02,15.64,15.65,15.64h24.1c8.63,0,15.65-7.02,15.65-15.64v-24.1c0-8.63-7.02-15.65-15.65-15.65ZM62.19,52.05c0,5.59-4.55,10.14-10.15,10.14h-24.1c-5.59,0-10.15-4.55-10.15-10.14v-24.1c0-5.59,4.55-10.15,10.15-10.15h24.1c5.59,0,10.15,4.55,10.15,10.15v24.1Z' fill='#4d3386'/>
      <path d='M40,25.07c-8.24,0-14.94,6.7-14.94,14.93s6.7,14.94,14.94,14.94,14.93-6.7,14.93-14.94-6.7-14.93-14.93-14.93ZM40,49.44c-5.2,0-9.44-4.23-9.44-9.44s4.23-9.43,9.44-9.43,9.43,4.23,9.43,9.43-4.23,9.44-9.43,9.44Z' fill='#4d3386'/>
      <path d='M54.52,21.94c-1.76,0-3.19,1.43-3.19,3.19s1.43,3.19,3.19,3.19,3.19-1.43,3.19-3.19-1.43-3.19-3.19-3.19Z' fill='#4d3386'/>
    </svg>
  );
});

InstagramCircleV2.displayName = 'InstagramCircleV2';
